module.exports = __webpack_public_path__ + "media/images/presta_busc/bioquimico-11966400cd5fe037272e17f9dfe773bb.svg";